<template>
  <u-animate-container>
    <!-- Menu -->
    <div class="mobile-menu-block clearfix">
      <div class="mobile-menu-inner clearfix">
        <div class="mobi-logo">
          <router-link :to="{ path: '/' }">
            <img
              src="https://growbiotech-prod.s3.amazonaws.com/1606973000233.png"
              alt
            />
          </router-link>
        </div>
        <nav class="mobile-nav">
          <ul>
            <li>
              <router-link :to="{ path: '/' }">Home</router-link>
            </li>
            <!-- <li>
              <router-link :to="{ path: '/' }">how it works</router-link>
            </li> -->
            <li>
              <v-menu offset-y open-on-hover>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="explore-btn" text v-bind="attrs" v-on="on"
                    >Explore
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in items"
                    :key="index"
                    :to="{ path: item.path }"
                  >
                    <v-list-item-title class="explore-menus">{{
                      item.title
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </li>
            <li>
              <router-link class="btn" :to="{ path: 'signup' }"
                >SIGN UP</router-link
              >
            </li>
            <li>
              <router-link :to="{ path: 'login' }">LOG IN</router-link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="menu-open-overlay">&nbsp;</div>
    <!-- Menu Icon -->
    <div class="mobi-iconbox mobilemenuicon">
      <div class="menuicon">
        <span class="icon-bar top-icon-bar"></span>
        <span class="icon-bar middle-icon-bar"></span>
        <span class="icon-bar bottom-icon-bar"></span>
      </div>
    </div>

    <!-- Header Start -->
    <home-header />
    <!-- Header End -->

    <!-- Section Start -->
    <div class="home-banner-section">
      <u-animate delay="0.4s" name="fadeInUp" class="container-cls wow">
        <div class="banner-image inner-padding">
          <img
            src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1609133955920.png"
            alt
          />
        </div>
        <div class="section-one-content-box">
          <div class="container-cls">
            <h2 class="home-content">
              <u-animate delay="0.4s" name="fadeInUp"
                ><span>Find your doctors and</span></u-animate
              >
              <u-animate delay="0.4s" name="fadeInUp"
                >book <strong>consultations</strong> online</u-animate
              >
            </h2>
            <h4 class="home-content">
              <u-animate delay="0.4s" name="fadeInUp"
                ><span
                  >Save yourself time and distance by easily</span
                ></u-animate
              >
              <u-animate delay="0.4s" name="fadeInUp"
                ><span>booking consultation with your doctor.</span></u-animate
              >
            </h4>
            <v-row v-if="$vuetify.breakpoint.smAndUp" class="search-doctor">
              <v-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3">
                <v-text-field
                  v-model="doctorName"
                  label="Search doctor"
                  solo
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3">
                <VAutoComplete
                  v-model="specialities"
                  :items="specialitiesList"
                  item-text="name"
                  item-value="_id"
                  placeholder="Select Speciality"
                  clearable
                  solo
                  class="speciality-select"
                  hide-details
                />
              </v-col>
              <v-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3">
                <VAutoComplete
                  v-model="clinic"
                  :items="clinicList"
                  item-text="name"
                  item-value="_id"
                  placeholder="Select Clinic"
                  clearable
                  solo
                  class="speciality-select"
                  hide-details
                />
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <v-btn
                  large
                  tile
                  min-height="48"
                  min-width="200"
                  color="#FCAE00"
                  class="white--text find-doctor-btn my-1"
                  @click="findDoctor"
                  >FIND DOCTOR</v-btn
                >
              </v-col>
            </v-row>
          </div>
        </div>
      </u-animate>
    </div>
    <div class="container-cls">
      <v-row v-if="$vuetify.breakpoint.xsOnly" class="search-doctor">
        <v-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3">
          <v-text-field
            v-model="doctorName"
            label="Search doctor"
            solo
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3">
          <VAutoComplete
            v-model="specialities"
            :items="specialitiesList"
            item-text="name"
            item-value="_id"
            placeholder="Select Speciality"
            clearable
            solo
            class="speciality-select"
            hide-details
          />
        </v-col>
        <v-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3">
          <VAutoComplete
            v-model="clinic"
            :items="clinicList"
            item-text="name"
            item-value="_id"
            placeholder="Select Clinic"
            clearable
            solo
            class="speciality-select"
            hide-details
          />
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="3"
          lg="3"
          xl="3"
          class="text-center"
        >
          <v-btn
            large
            tile
            min-height="48"
            color="#FCAE00"
            class="white--text find-doctor-btn my-1"
            @click="findDoctor"
            >FIND DOCTOR</v-btn
          >
        </v-col>
      </v-row>
    </div>

    <!-- Section 2 Start -->
    <div class="container-cls" v-if="$vuetify.breakpoint.smAndUp"></div>
    <u-animate
      name="fadeInRight"
      delay="0.4s"
      v-if="$vuetify.breakpoint.smAndUp"
    >
      <!-- <div class="container-cls"> -->
      <div class="background-image-bg1"></div>
      <!-- </div> -->
    </u-animate>
    <div class="background-image-box">
      <u-animate name="fadeInRight" delay="0.4s" class="col-12 wow">
        <div class="container-cls">
          <h3 class="text-center content-color py-5">
            <div
              class="background-image-bg2"
              v-if="$vuetify.breakpoint.smAndUp"
            ></div>
            In our database we have more than 150 doctors
          </h3>
          <v-row class="justify-center">
            <v-card class="vcard-box">
              <v-card-title class="desg-box">
                <img
                  src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1633005424709.png"
                  alt
                />
                <v-spacer></v-spacer>
                <v-card-title class="content-color">
                  General Practice
                </v-card-title>
              </v-card-title>
            </v-card>
            <v-card class="vcard-box">
              <v-card-title class="desg-box">
                <img
                  src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1633005482493.png"
                  alt
                />
                <v-spacer></v-spacer>
                <v-card-title class="content-color"> Orthopedics </v-card-title>
              </v-card-title>
            </v-card>
          </v-row>
          <v-row class="justify-center">
            <v-card class="vcard-box">
              <v-card-title class="desg-box">
                <img
                  src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1633005508771.png"
                  alt
                />
                <v-spacer></v-spacer>
                <v-card-title class="content-color">Neurology</v-card-title>
              </v-card-title>
            </v-card>
            <v-card class="vcard-box">
              <v-card-title class="desg-box">
                <img
                  src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1633005543730.png"
                  alt
                />
                <v-spacer></v-spacer>
                <v-card-title class="content-color"
                  >Anesthesiology</v-card-title
                >
              </v-card-title>
            </v-card>
            <v-card class="vcard-box">
              <v-card-title class="desg-box">
                <img
                  src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1633005567126.png"
                  alt
                />
                <v-spacer></v-spacer>
                <v-card-title class="content-color">Ophthalmology</v-card-title>
              </v-card-title>
            </v-card>
          </v-row>
          <v-row class="justify-center">
            <v-card class="vcard-box">
              <v-card-title class="desg-box">
                <img
                  src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1633005590579.png"
                  alt
                />
                <v-spacer></v-spacer>
                <v-card-title class="content-color">Cardiology</v-card-title>
              </v-card-title>
            </v-card>
            <v-card class="vcard-box">
              <v-card-title class="desg-box">
                <img
                  src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1633005610137.png"
                  alt
                />
                <v-spacer></v-spacer>
                <v-card-title class="content-color">Pulmonology</v-card-title>
              </v-card-title>
            </v-card>
          </v-row>
        </div>
      </u-animate>
    </div>

    <!-- Section 3 Start -->
    <div class="two-col-section medicine-section">
      <div class="container-cls">
        <u-animate delay="0.4s" name="fadeInUp" class="container-cls wow">
          <div class="banner-image inner-padding">
            <img
              src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1609134053397.png"
              alt
            />
          </div>
          <div class="section-three-content-box">
            <div class="col-12 wow text-center">
              <div class="container-cls">
                <h2 class="home-content2">
                  Connecting patients and medical organizations
                </h2>
                <h4 class="home-content1">
                  Patients can book appointments with doctors in real-time
                </h4>
              </div>
            </div>
          </div>
        </u-animate>
      </div>
    </div>

    <!-- Clinic section start -->
    <div
      class="two-col-section medicine-section pt-0 pb-10"
      v-if="clinicSlider.length > 0"
    >
      <div class="container-cls">
        <h3 class="text-center content-color mb-0">In cooperation with</h3>
        <v-sheet class="mx-auto" max-width="1000">
          <v-slide-group class="px-8 clinic-slider" center-active show-arrows>
            <v-slide-item v-for="(clinic, index) in clinicSlider" :key="index">
              <v-card class="pa-3 clinic-images" width="160" elevation="0">
                <img :src="clinic.img" :alt="clinic.name" />
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-sheet>
      </div>
    </div>

    <!-- Last Section Start -->
    <div class="get-a-quote-section start">
      <div class="container-cls">
        <u-animate name="fadeInUp" delay="0.4s" class="wow py-3 text-center">
          <h4 class="white--text">
            <span>HOW DOES IT WORK?</span>
          </h4>
        </u-animate>
        <v-row cols="12" class="px-10 pa-4">
          <v-col cols="12" sm="6" md="4" class="wow steps-content">
            <u-animate name="bounceInLeft" delay="0.2s">
              <div class="icon-with-content">
                <i class="icon">
                  <img
                    src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1609146930047.png"
                    alt
                  />
                </i>
                <div class="content-box white--text">
                  <span>Step 1.</span><br />
                  <span>Apply and Create a Profile</span>
                </div>
              </div>
            </u-animate>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="wow steps-content">
            <u-animate name="bounceInLeft" delay="0.4s">
              <div class="icon-with-content">
                <i class="icon">
                  <img
                    src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1609150494544.png"
                    alt
                  />
                </i>
                <div class="content-box white--text">
                  <span>Step 2.</span><br />
                  <span>Find Doctor and Hospital</span>
                </div>
              </div>
            </u-animate>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="wow steps-content">
            <u-animate name="bounceInLeft" delay="0.6s">
              <div class="icon-with-content">
                <i class="icon">
                  <img
                    src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1609150558572.png"
                    alt
                  />
                </i>
                <div class="content-box white--text">
                  <span>Step 3.</span><br />
                  <span>Book an Appointment</span>
                </div>
              </div>
            </u-animate>
          </v-col>
        </v-row>
      </div>
    </div>

    <!-- Footer Start -->
    <home-footer />
    <!-- Footer End -->

    <!-- Cookie alert model -->
    <AcceptCookie />
  </u-animate-container>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
import Header from "./Header";
import Footer from "./Footer";
import { VAutoComplete } from "@/components/inputs";
import { AuthService } from "@/services";

export default {
  name: "Home",
  components: {
    UAnimateContainer,
    UAnimate,
    HomeHeader: Header,
    HomeFooter: Footer,
    VAutoComplete,
    AcceptCookie: () => import("@/components/AcceptCookie")
  },
  data() {
    return {
      doctorName: "",
      specialitiesList: [],
      specialities: null,
      clinicList: [],
      clinicSlider: [],
      clinic: null,
      items: [
        { title: "News & Articles", path: "/news-feed" },
        { title: "Find Doctor", path: "/find-doctor" }
      ]
    };
  },
  mounted() {
    const jQuery = require("jquery");

    jQuery(document).ready(function() {
      /// Moble Menu Script
      jQuery(".mobilemenuicon").click(function() {
        jQuery(this).toggleClass("opened");
        jQuery("body").toggleClass("mobile-menu-open");
      });
      jQuery(".menu-open-overlay, .mobile-nav li > a").click(function() {
        jQuery("body").removeClass("mobile-menu-open");
        jQuery("body").removeClass("open");
        jQuery(".mobilemenuicon").removeClass("opened");
      });

      /* scroll bottom to top */
      if (jQuery(this).scrollTop() > 200) {
        jQuery(".scrollup").fadeIn();
      } else {
        jQuery(".scrollup").fadeOut();
      }
      jQuery(window).scroll(function() {
        if (jQuery(this).scrollTop() > 200) {
          jQuery(".scrollup").fadeIn();
        } else {
          jQuery(".scrollup").fadeOut();
        }
      });
      jQuery(".scrollup").click(function() {
        jQuery("html, body").animate(
          {
            scrollTop: 0
          },
          600
        );
        return false;
      });

      /* Sticky Header */
      jQuery(document).on("scroll", function() {
        if (jQuery(document).scrollTop() > 0) {
          jQuery("body").addClass("header-fixed");
        } else {
          jQuery("body").removeClass("header-fixed");
        }
      });

      if (jQuery(document).scrollTop() > 0) {
        jQuery("body").addClass("header-fixed");
      } else {
        jQuery("body").removeClass("header-fixed");
      }
    });
    this.getSpecialityList();
    this.getClinicList();
  },
  methods: {
    async getSpecialityList() {
      const response = await AuthService.getSpeciality();
      this.specialitiesList = response.data;
    },
    findDoctor() {
      this.$router.push({
        name: "Find-Doctors",
        params: {
          search: this.doctorName,
          speciality: this.specialities,
          clinic: this.clinic
        }
      });
    },
    async getClinicList() {
      const clinicData = await AuthService.getClinics();
      this.clinicList = clinicData.data ? clinicData.data : [];
      this.clinicList.forEach(clinic => {
        if (clinic.media.length > 0 && clinic.media[0].url)
          this.clinicSlider.push({
            name: clinic.name,
            img: clinic.media[0].url
          });
      });
    }
  }
};
</script>
<style>
.speciality-select .success--text {
  color: rgba(0, 0, 0, 0.54) !important;
}
.clinic-images {
  margin: auto !important;
}
.clinic-slider .v-icon.v-icon {
  font-size: 45px;
}
</style>
